// extracted by mini-css-extract-plugin
export default {"tableWrapper":"MyTemplates_tableWrapper__3K-Qg"};